var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-2",attrs:{"tile":"","flat":"","height":"500","text":""}},[_c('v-chart',{attrs:{"auto-resize":"","options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }